// extracted by mini-css-extract-plugin
export default {"button":"indicador_button__GgewT","filtro":"indicador_filtro__9if0r"};